if($('.talent-community-content').length) {
    let hasAdjustedForm = false;

    let formCleanup = setInterval(function () {
        if($('#mc_embed_signup').length) {
            hasAdjustedForm = true;
            clearInterval(formCleanup);

            $('#mc-embedded-subscribe').removeClass('button').addClass('btn btn-primary btn-lg btn-red');
            $('#mc-embedded-subscribe').val('Join The Centerline Driver Community');

            $('.mobile-form input[type=submit]').removeClass('button').addClass('btn btn-primary btn-lg btn-red');
            $('.mobile-form input[type=submit]').val('Join The Centerline Driver Community');

            // let selectTags = $('#mc_embed_signup').find('form')[0].getElementsByTagName("select");
            //
            // for(let i = 0; i < selectTags.length; i++) {
            //     selectTags[i].selectedIndex = 1;
            // }
            //
            // let selectTagsMobile = $('.mobile-form').find('form')[0].getElementsByTagName("select");
            //
            // for(let i = 0; i < selectTagsMobile.length; i++) {
            //     selectTagsMobile[i].selectedIndex = 1;
            // }

            $('.mc-field-group').each(function () {

                if($(this).find('select').length) {
                    $(this).addClass('has-select');
                }

            });

            $('.talent-community-content').find('input').on('keyup update input focusin focus focusout', function () {
                inputLabelDisplayStatusCheck();
            });

            $('.talent-community-content').find('select').on('keyup update input focusin focus focusout', function () {
                inputLabelDisplayStatusCheck();
            });

            $('.talent-community-content').find('input[type="radio"]').on('keyup update input', function () {
                inputLabelDisplayStatusCheck();
            });

            $('.talent-community-content').find('input[type="checkbox"]').on('keyup update input', function () {
                inputLabelDisplayStatusCheck();
            });

            $('.talent-community-content').on('click', function () {
                inputLabelDisplayStatusCheck();
            })

            function inputLabelDisplayStatusCheck() {

                $('.talent-community-content').find('.mc-field-group').each(function () {

                    let isPopulated = false;

                    if($(this).find('input').length && ($(this).find('input').val().length || $(this).find('input').is(':focus'))) {
                        isPopulated = true;
                    }

                    if(isPopulated) {
                        $(this).addClass('input-focused-populated');
                    } else {
                        $(this).removeClass('input-focused-populated');
                    }

                });

            }
        }
    }, 300);
}
